import { render, staticRenderFns } from "./CustomerQuestions.vue?vue&type=template&id=72d7553a&scoped=true&"
import script from "./CustomerQuestions.vue?vue&type=script&lang=js&"
export * from "./CustomerQuestions.vue?vue&type=script&lang=js&"
import style0 from "./CustomerQuestions.vue?vue&type=style&index=0&id=72d7553a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d7553a",
  null
  
)

export default component.exports